import React from "react";
import {
  GetServerSideProps,
  InferGetServerSidePropsType,
  NextPage,
} from "next";
import Head from "next/head";

import { getProductMarketplaceCategories } from "api/requests/getProductMarketplaceCategories";
import useDomain from "hooks/useDomain";
import { getCountryCodeHeader } from "utils/requestContext";

import LandingPage from "components/products/LandingPage/LandingPage";
import { ProductCategoryGoogleAdTargeting } from "components/products/ProductCategoryGoogleAdTargeting";

const ProductIndex: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ categories, isCanada }) => {
  const domain = useDomain();

  return (
    <>
      <Head>
        <link rel="canonical" href={`${domain}/products`}></link>
        <link
          rel="alternate"
          href="https://www.leafly.com/products"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.leafly.ca/products"
          hrefLang="en-ca"
        />
      </Head>
      <ProductCategoryGoogleAdTargeting category="home" />
      <LandingPage categories={categories} isCanada={isCanada} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const countryCode = getCountryCodeHeader(ctx);
  const { categories } = await getProductMarketplaceCategories(countryCode);
  const isCanada = countryCode === "CA";

  return {
    props: {
      categories,
      isCanada,
    },
  };
};

export default ProductIndex;
